function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHomeAlternative = function SvgIconHomeAlternative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M4 20v-7.291a.5.5 0 0 1 .13-.337l7.5-8.225a.5.5 0 0 1 .74 0l7.5 8.225a.5.5 0 0 1 .13.337V20a.5.5 0 0 1-.5.5h-4.598a.5.5 0 0 1-.5-.5v-2.723a2.402 2.402 0 0 0-4.804 0V20a.5.5 0 0 1-.5.5H4.5A.5.5 0 0 1 4 20Z"
  }));
};
export default SvgIconHomeAlternative;